module.exports = __webpack_public_path__ + "img/badge_gray_spe-mobile.4c6a0fd5.svg";